export default __webpack_public_path__ + "static/media/card1@2x.bb11b667.png";